import { BASE_URL } from '@src/typescriptGlobals/constants';
import { JsonLdPropTypes } from './JsonLd.types';

const JsonLd = ({ pageUrl, name, thumbnailUrl, datePublished, dateModified, description, locale }: JsonLdPropTypes) => {
  const todayDate = new Date();
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${BASE_URL}${pageUrl ?? '/'}`,
        url: `${BASE_URL}${pageUrl ?? '/'}`,
        name: name ?? 'Vald Performance',
        isPartOf: { '@id': `${BASE_URL}/${locale}/#website` },
        about: { '@id': `${BASE_URL}/${locale}/#organization` },
        primaryImageOfPage: {
          '@id': `${BASE_URL}/${locale}/#primaryimage`,
        },
        image: { '@id': `${BASE_URL}/${locale}/#primaryimage` },
        thumbnailUrl,
        datePublished: datePublished ?? todayDate,
        dateModified: dateModified ?? todayDate,
        description: description ?? 'Vald Performance',
        inLanguage: 'en-US',
        potentialAction: [
          {
            '@type': 'ReadAction',
            target: [`${BASE_URL}/${locale}`],
          },
        ],
      },
      {
        '@type': 'ImageObject',
        inLanguage: 'en-US',
        '@id': `${BASE_URL}/${locale}/#primaryimage`,
        url: thumbnailUrl ?? '',
        contentUrl: thumbnailUrl ?? '',
        width: 1000,
        height: 800,
      },
      {
        '@type': 'WebSite',
        '@id': `${BASE_URL}/${locale}/#website`,
        url: `${BASE_URL}/${locale}`,
        name: 'VALD Performance | Human Measurement Technologies',
        description: 'Move. Measure. Modify',
        publisher: {
          '@id': `${BASE_URL}/${locale}/#organization`,
        },
        inLanguage: 'en-US',
      },
      {
        '@type': 'Organization',
        '@id': `${BASE_URL}/${locale}/#organization`,
        name: 'VALD Performance',
        url: `${BASE_URL}/${locale}`,
        logo: {
          '@type': 'ImageObject',
          inLanguage: 'en-US',
          '@id': `${BASE_URL}/${locale}/#/schema/logo/image/`,
          url: '',
          contentUrl: '',
          caption: 'VALD Performance',
        },
        image: {
          '@id': `${BASE_URL}/${locale}/#/schema/logo/image/`,
        },
      },
    ],
  };
};

export default JsonLd;
